"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildQueryString = void 0;
const buildQueryString = (data) => {
    if (!data) {
        return "";
    }
    const queryParts = Object.entries(data)
        .filter(([_, value]) => value !== undefined && value !== null)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    return `?${queryParts.join("&")}`;
};
exports.buildQueryString = buildQueryString;
